import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Branch } from "../../../../../../../../models/branch";
import Input from "../../../../../../../../components/Form/Input";

interface Props {
  isOnViewMode?: boolean;
  branch?: Branch;
  isFetching?: boolean;
  getErrorByField?: (field: string) => string | undefined;
  setBranch: (branch: Branch) => void;
}

const General = (props: Props) => {
  const { isFetching = false, isOnViewMode, branch, getErrorByField, setBranch } = props;
  const { t: translate } = useTranslation();

  return (
    <Grid container direction="row" alignItems="flex-start" spacing={2}>
      <Grid item md={6} lg={6}>
        <Input
          name="code"
          label={translate("code")}
          disabled={isOnViewMode || isFetching}
          placeholder={translate("code")}
          value={branch?.code || ""}
          onChange={(event) =>
            setBranch(
              branch
                ? { ...branch, code: event.target.value }
                : ({ code: event.target.value } as Branch)
            )
          }
          error={!!(getErrorByField && getErrorByField("code"))}
          errorMessage={getErrorByField && getErrorByField("code")}
        />
      </Grid>
      <Grid item md={6} lg={6}>
        <Input
          name="name"
          label={translate("name")}
          placeholder={translate("name")}
          disabled={isOnViewMode || isFetching}
          value={branch?.name || ""}
          onChange={(event) =>
            setBranch(
              branch
                ? { ...branch, name: event.target.value }
                : ({ name: event.target.value } as Branch)
            )
          }
          error={!!(getErrorByField && getErrorByField("name"))}
          errorMessage={getErrorByField && getErrorByField("name")}
        />
      </Grid>
      <Grid item md={12} lg={12}>
        <Input
          name="description"
          label={translate("description")}
          disabled={isOnViewMode || isFetching}
          placeholder={translate("description")}
          value={branch?.description}
          onChange={(event) =>
            setBranch(
              branch
                ? { ...branch, description: event.target.value }
                : ({ description: event.target.value } as Branch)
            )
          }
          error={!!(getErrorByField && getErrorByField("description"))}
          errorMessage={getErrorByField && getErrorByField("description")}
        />
      </Grid>
    </Grid>
  );
};

export default General;
